import React from "react"
import * as S from "./pdf.styles"

const Pdf = ({ pdfUrl }) => {
  return (
    <S.Wrapper maxWidth="md">
      <div className="wrapper">
        {pdfUrl && <iframe src={pdfUrl.mediaItemUrl} type="application/pdf" />}
      </div>
    </S.Wrapper>
  )
}

export default Pdf
